import React from "react";
//import { useAuth } from "./../../../components/content/auth.jsx";
import { Api } from "./../../../app-controller.js";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import Swal from "sweetalert2";

class DropdownNotification extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.shownote = this.shownote.bind(this);
    this.showall = this.showall.bind(this);
    this.readInbox = this.readInbox.bind(this);

    this.state = {
      dropdownOpen: false,
      nots: 0,
      notify: [],
    };

    this.readInbox();

    let ri = 0;
    let inActivo = true;
    let inActividad = 0;
    let stopT = false;
    const liveApp = setInterval(() => {
      if (localStorage.getItem("sesion") === null) {
        return;
      }

      if (stopT) {
        return;
      }
      //Revisar inbox cada 30s

      if (ri === 30) {
        //this.readInbox();
        ri = 0;
      } else {
        ri++;
      }

      let statusSesion = localStorage.getItem("expirado");

      if (statusSesion !== "0") {
        window.location.href = "/login";
      }

      /** 60 segundos * 30 */
      if (inActividad === 60 * 30) {
        let user = JSON.parse(localStorage.user);
        stopT = true;

        localStorage.setItem("expirado", "1");

        Swal.fire({
          title: "Tu sesión expiró, por favor accede de nuevo.",
          html: `<input type="email" value="${user.email}" disabled id="ilogin" class="swal2-input" placeholder="Usuario" readonly>
			`,
          input: "password",
          inputAttributes: {
            id: "ipassword",
            placeholder: "Ingrese contraseña",
          },
          showCancelButton: true,
          confirmButtonText: "Acceder",
          cancelButtonText: "Salir",
          showLoaderOnConfirm: true,
          reverseButtons: true,
          cancelButtonColor: "Red",
          confirmButtonColor: "#4CD964",
          // allowOutsideClick: false,
          preConfirm: (login) => {
            let password = document.getElementById("ipassword").value;

            if (!password) {
              Swal.showValidationMessage(`Ingrese contraseña`);
            } else {
              try {
                return Api.fetch(
                  "auth/login",
                  {
                    email: document.getElementById("ilogin").value,
                    password: document.getElementById("ipassword").value,
                  },
                  "POST"
                ).then((response) => {
                  if (!response) {
                    window.location.href = "/login";
                  } else {
                    localStorage.setItem("expirado", "0");
                  }
                  return response;
                });
              } catch (e) {
                window.location.href = "/login";
              }
            }
          },
          allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
          if (!result.isConfirmed) {
            window.location.href = "/login";
          }
          stopT = false;
          inActividad = 0;
        });
      } else {
        //Monitorear actividad cada 1s
        if (inActivo) {
          inActividad++;
        } else {
          inActividad = 0;
        }
      }
    }, 1000);

    let domApp = document.getElementById("root");
    domApp.addEventListener("keydown", (e) => {
      inActivo = 1;
      inActividad = 0;
    });
    domApp.addEventListener("mousemove", (e) => {
      inActivo = 1;
      inActividad = 0;
    });
  }

  readInbox() {
    if (localStorage.token !== undefined) {
      Api.fetch("app/getInboxBell").then((inbox) => {
        if (inbox) {
          this.setState({ nots: inbox.total, notify: inbox.last5.data });
        }
      });
    }
  }
  showall() {
    window.location.href = "/notificaciones";
  }
  shownote(not) {
    let nota = this.state.notify[not.target.dataset.id];
    Api.fetch("app/readed?id=" + nota.id).then((r) => {
      Swal.fire({
        title: nota.asunto,
        html: nota.contenido,
      });
      if (localStorage.token !== undefined) {
        Api.fetch("app/getInboxBell").then((inbox) => {
          if (inbox) {
            this.setState({ nots: inbox.total, notify: inbox.last5.data });
          }
        });
      }
    });
  }

  toggle() {
    this.setState((prevState) => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
    this.readInbox();
  }

  render() {
    return (
      <Dropdown
        isOpen={this.state.dropdownOpen}
        toggle={this.toggle}
        className="dropdown"
        tag="li"
      >
        <DropdownToggle className="f-s-18" tag="a">
          <i className="f-s-22 fa fa-bell"></i>
          <span className="label">{this.state.nots}</span>
        </DropdownToggle>
        <DropdownMenu className="media-list dropdown-menu-right" tag="ul">
          <DropdownItem className="dropdown-header" tag="li" header>
            ({this.state.nots}) Notificaciones
          </DropdownItem>
          {this.state.notify.map((not, index) => (
            <DropdownItem
              onClick={this.shownote}
              id={"i-" + index}
              data-id={index}
              key={index}
              className="text-center p-10"
            >
              {not.asunto}
            </DropdownItem>
          ))}
          <DropdownItem onClick={this.showall} className="text-center p-10">
            Mostrar todas
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    );
  }
}

export default DropdownNotification;
